/**
 * Uses Swiper package to create a carousel for product media
 * More info: https://swiperjs.com/
 */
class ProductMedia extends HTMLElement {
  /**
   * constructor.
   */
  constructor() {
    super();

    this.selectors = {
      slider: '[data-slider]',
      thumbs: '[data-thumbs]',
      mediaItem: '[data-slide-media-id]',
      gallerySlides: '[data-gallery-slide]',
      thumbsSlides: '[data-thumbs-slide]',
    };
    this.selectedMediaIndex =
      Number(
        this.querySelector(this.selectors.slider).querySelector(
          '[data-selected]',
        )?.dataset.index,
      ) || 0;
    this.settings = {
      elements: {
        slider: this.querySelector(this.selectors.slider),
        thumbs: this.querySelector(this.selectors.thumbs),
      },
      instances: {
        slider: null,
        thumbs: null,
      },
      options: {
        slider: {
          initialSlide: this.selectedMediaIndex,
          spaceBetween: 20,
          watchOverflow: true,
          navigation: {
            prevEl: this.querySelector('.swiper-arrow--prev'),
            nextEl: this.querySelector('.swiper-arrow--next'),
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
        },
        thumbs: {
          initialSlide: this.selectedMediaIndex,
          slidesPerView: 5,
          spaceBetween: 16,
        },
      },
    };
  }

  /**
   * connectedCallback.
   */
  connectedCallback() {
    this.init();
  }

  /**
   * init.
   */
  init() {
    if (!this.settings.elements.slider || !this.settings.elements.thumbs)
      return;

    this.settings.instances.thumbs = new Swiper(
      this.settings.elements.thumbs,
      this.settings.options.thumbs,
    );
    this.settings.options.slider.thumbs = {
      swiper: this.settings.instances.thumbs,
    };

    this.settings.instances.slider = new Swiper(
      this.settings.elements.slider,
      this.settings.options.slider,
    );
  }

  /**
   * setActiveMedia.
   * @param {String} mediaId - Media id.
   */
  setActiveMedia(mediaId) {
    const mediaFound = Array.from(
      this.querySelectorAll(this.selectors.mediaItem),
    ).find((media) => Number(media.dataset.mediaId) === mediaId);
    if (!mediaFound) return;
    this.settings.instances.slider.slideTo(Number(mediaFound.dataset.index));
  }

  /**
   * slideToVariantMedia.
   * @param {String} mediaId
   * @returns {return-type} - Return type description.
   */
  slideToVariantMedia(mediaId) {
    if (!mediaId) return;

    const targetSlide = this.querySelector(
      `${this.selectors.gallerySlides}[data-slide-media-id="${mediaId}"]`,
    );

    const targetIndex = Array.from(
      this.querySelectorAll(this.selectors.gallerySlides),
    )
      .filter((slide) => !slide.classList.contains('hidden'))
      .indexOf(targetSlide);

    this.settings.instances.slider.slideTo(targetIndex);
    this.settings.instances.thumbs.slideTo(targetIndex);
  }

  toggleSlidesByColor(color) {
    if (!color) return;

    const allSlidesArray = [
      ...this.querySelectorAll(this.selectors.gallerySlides),
      ...this.querySelectorAll(this.selectors.thumbsSlides),
    ];

    const formatString = (string) => {
      if (!string) return;

      return string.toLowerCase().replaceAll(' ', '-');
    };

    allSlidesArray.forEach((slide) => {
      const colorMatchingOrMissing =
        !slide.dataset.color ||
        formatString(color) === formatString(slide.dataset.color);

      slide.classList.toggle('swiper-slide', colorMatchingOrMissing);
      slide.classList.toggle('hidden', !colorMatchingOrMissing);
    });

    this.settings.instances.slider.update();
    this.settings.instances.thumbs.update();
  }
}

customElements.define('product-media', ProductMedia);
